import React from 'react';

import './styles.css';

// This status is defined at the BE (permissions/constants)
export const MEMBER_STATUSES = {
  ACTIVE: 'Active',
  PENDING: 'Pending',
  DISABLED: 'Disabled',
  INVITE_EXPIRED: 'Invite Expired',
  NEWLY_CREATED: 'Newly Created'
};

const colors = {
  [MEMBER_STATUSES.ACTIVE]: 'var(--apple)',
  [MEMBER_STATUSES.PENDING]: '#ffbd5e',
  [MEMBER_STATUSES.DISABLED]: 'var(--greyish-blue)',
  [MEMBER_STATUSES.INVITE_EXPIRED]: 'var(--greyish-blue)',
  [MEMBER_STATUSES.NEWLY_CREATED]: '#dc8d8d'
};

const MemberStatus = ({status}) => (
  <div className="MemberStatus" style={{backgroundColor: colors[status]}}>
    {status}
  </div>
);

export default MemberStatus;
